import yesOrNoChange from './actions/yesOrNoChange';
import yesOrNoCreate from './actions/yesOrNoCreate';
import yesOrNoDetail from './actions/yesOrNoDetail';
import yesOrNoList from './actions/yesOrNoList';
import getYesOrNo from './getters/getYesOrNo';
import yesOrNoUpload from './mutations/yesOrNoUpload';

const actions = {
    yesOrNoChange,
    yesOrNoCreate,
    yesOrNoDetail,
    yesOrNoList
};

const mutations = {
    yesOrNoUpload
};

const getters = {
    getYesOrNo
};

export default { actions, mutations, getters };
